import React, { useState, useCallback, useMemo } from 'react';
import CreateAssessmentTemplate from 'js/components/Assessment/CreateAssessmentTemplate';

import { Icon } from 'js/components';
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap';
import { faLightbulb } from '@fortawesome/pro-regular-svg-icons';

import styles from './CreateAssessmentsComponent.module.scss';

const RECOMMENDED_TEMPLATES = {
  SQUAD_HEALTH_CHECK: 0,
  SQUAD_HEALTH_CHECK_GENERAL: 3,
  WAYPOINTR_CAPABILITIES: 12,
};

function AlternativeRecommendations({ currentTopRecommendation, onSelect }) {
  const selectHealthCheck = useCallback(() => {
    onSelect(RECOMMENDED_TEMPLATES.SQUAD_HEALTH_CHECK);
  }, [onSelect]);

  const selectWaypointrCapabilities = useCallback(() => {
    onSelect(RECOMMENDED_TEMPLATES.WAYPOINTR_CAPABILITIES);
  }, [onSelect]);

  const selectGeneralHealthCheck = useCallback(() => {
    onSelect(RECOMMENDED_TEMPLATES.SQUAD_HEALTH_CHECK_GENERAL);
  }, [onSelect]);

  const buttonProps = useMemo(
    () => ({
      className: 'btn btn-link mb-0',
      style: {
        fontSize: '1em',
        border: 'none',
        lineHeight: '24px',
        marginTop: '-2.5px',
      },
    }),
    []
  );

  switch (currentTopRecommendation) {
    case RECOMMENDED_TEMPLATES.SQUAD_HEALTH_CHECK_GENERAL:
      return (
        <ul className="list-unstyled">
          <li>
            <Icon className="icon-left text-info" icon={faLightbulb} />
            Have a software team? Use{' '}
            <button {...buttonProps} onClick={selectHealthCheck}>
              Squad Health Check (Software)
            </button>
          </li>
          <li>
            <Icon className="icon-left text-info" icon={faLightbulb} />
            Looking for something more comprehesive? Try the{' '}
            <button {...buttonProps} onClick={selectWaypointrCapabilities}>
              Waypointr Capabilities Assessment
            </button>
          </li>
        </ul>
      );
    case RECOMMENDED_TEMPLATES.WAYPOINTR_CAPABILITIES:
      return (
        <ul className="list-unstyled">
          <li>
            <Icon className="icon-left text-info" icon={faLightbulb} />
            Looking for something short and sweet? Use{' '}
            <button {...buttonProps} onClick={selectHealthCheck}>
              Squad Health Check (Software)
            </button>{' '}
            or{' '}
            <button {...buttonProps} onClick={selectGeneralHealthCheck}>
              Squad Health Check (General)
            </button>
          </li>
        </ul>
      );
    default:
      return (
        <ul className="list-unstyled">
          <li>
            <Icon className="icon-left text-info" icon={faLightbulb} />
            Not a software team? Use{' '}
            <button {...buttonProps} onClick={selectGeneralHealthCheck}>
              Squad Health Check (General)
            </button>
          </li>
          <li>
            <Icon className="icon-left text-info" icon={faLightbulb} />
            Looking for something more comprehesive? Try the{' '}
            <button {...buttonProps} onClick={selectWaypointrCapabilities}>
              Waypointr Capabilities Assessment
            </button>
          </li>
        </ul>
      );
  }
}

function RecommendedAssessments({ templates }) {
  const [topRecommendation, setTopRecommendation] = useState(
    RECOMMENDED_TEMPLATES.SQUAD_HEALTH_CHECK
  );

  const recommendedTemplate = templates.find((x) => x.id === topRecommendation);

  return recommendedTemplate ? (
    <Card className={styles['recommended-assessments']}>
      <CardHeader>
        <CardTitle tag="h5">Top recommendations for you</CardTitle>
      </CardHeader>
      <CardBody>
        <div className={styles['recommended-assessments-list']}>
          <CreateAssessmentTemplate template={recommendedTemplate} />
        </div>
        <div className={styles['recommended-assessments-alternatives']}>
          <h6 className="text-info">Alternatives</h6>
          <AlternativeRecommendations
            currentTopRecommendation={topRecommendation}
            onSelect={setTopRecommendation}
          />
        </div>
      </CardBody>
    </Card>
  ) : null;
}

export default RecommendedAssessments;
